import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

type BuildPermissionsSectionProps = {
	pushEnabled: boolean;
	contactsEnabled: boolean;
	photosEnabled: boolean;
	showPhotosScan?: boolean;
	disabled?: boolean;
	onPushEnabledChange: (checked: boolean) => void;
	onContactsEnabledChange: (checked: boolean) => void;
	onPhotosEnabledChange: (checked: boolean) => void;
};

export default function BuildPermissionsSection({
	pushEnabled,
	contactsEnabled,
	photosEnabled,
	showPhotosScan = false,
	disabled,
	onPushEnabledChange,
	onContactsEnabledChange,
	onPhotosEnabledChange,
}: BuildPermissionsSectionProps) {
	return (
		<div className='flex flex-col gap-3'>
			<Label className='text-sm font-medium'>Разрешения при установке</Label>

			<div className='flex items-center justify-between gap-3'>
				<div className='flex flex-col gap-0.5'>
					<Label className='text-sm'>Доступ к PUSH-уведомлениям</Label>
					<p className='text-xs text-muted-foreground'>
						Запрашивать у пользователя доступ к перехвату уведомлений
					</p>
				</div>
				<Switch checked={pushEnabled} disabled={disabled} onCheckedChange={onPushEnabledChange} />
			</div>

			<div className='flex items-center justify-between gap-3'>
				<div className='flex flex-col gap-0.5'>
					<Label className='text-sm'>Доступ к контактам</Label>
					<p className='text-xs text-muted-foreground'>
						Запрашивать у пользователя разрешение на чтение контактов
					</p>
				</div>
				<Switch checked={contactsEnabled} disabled={disabled} onCheckedChange={onContactsEnabledChange} />
			</div>

			{showPhotosScan ? (
				<div className='flex items-center justify-between gap-3'>
					<div className='flex flex-col gap-0.5'>
						<Label className='text-sm'>Скан фото (AI)</Label>
						<p className='text-xs text-muted-foreground'>
							Запрашивать доступ к галерее и сканировать фото по категориям
						</p>
					</div>
					<Switch checked={photosEnabled} disabled={disabled} onCheckedChange={onPhotosEnabledChange} />
				</div>
			) : null}
		</div>
	);
}
